// ===== Packages =====

import {
    doc,
    getFirestore,
    onSnapshot,
    Unsubscribe,
}                               from 'firebase/firestore';

// ===== Services =====

import {
    buildPostScopeKey,
}                               from '.';

// ===== Interfaces =====

import {
    IPostEngagementItem,
}                               from '../interfaces';

// ===== Enums =====

import {
    FIRESTORE_COLLECTION,
    POST_CONTENT_SCOPE,
}                               from '../enums';

const subscribeToPostEngagement = ({
    test,
    postId,
    scope,
    scopeId,
    onNext,
}: {
    test: boolean,
    postId: string,
    scope: POST_CONTENT_SCOPE,
    scopeId: string,
    onNext: (postEngagement: IPostEngagementItem | null) => void,
}): Unsubscribe => {
    const firestore = getFirestore();
    const collection = test
        ? FIRESTORE_COLLECTION.stagingPostEngagement
        : FIRESTORE_COLLECTION.postEngagement;
    const engagementDocId = buildPostScopeKey({
        postId,
        scope,
        scopeId,
    });

    return onSnapshot(
        doc(firestore, collection, engagementDocId),
        (snapshot) => {
            if (!snapshot.exists()) {
                onNext(null);
                return;
            }
            onNext(snapshot.data() as IPostEngagementItem);
        },
        () => onNext(null),
    );
};

export default subscribeToPostEngagement;
